import React, {useEffect} from 'react';
import Responsive, {useMediaQuery} from 'react-responsive';
import SessionStore from '~/stores/SessionStore';


export const Desktop = props => <Responsive {...props} minWidth={1080} />;

export const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={1079} />;

export const Mobile = props => <Responsive {...props} maxWidth={767} />;

export const DesktopOrTablet = props => <Responsive {...props} minWidth={768} />;

export const MediaQuery = (props) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)'
  });

  useEffect(() => {
    document.body.style.height = window.innerHeight;
    document.body.className = isMobile && !props.forceDesktop ? 'media-mobile' : 'media-desktop-or-tablet';
    SessionStore.setDeviceInfo(isMobile);
  });

  return props.children;
};
